import React, { memo, SVGAttributes } from 'react';

export interface FolderIconProps extends SVGAttributes<SVGElement> {}

export const FolderIcon = memo(function FolderIcon(props: FolderIconProps) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.0751 10.8334C15.1917 10.9834 15.3084 11.1334 15.4084 11.2917L17.1584 14.0667H34.1667V10.8334H15.0751Z"
        fill="#116DFF"
      />
      <path
        d="M17.1333 14.025L15.3833 11.1C14.3604 9.38619 12.5125 8.33564 10.5166 8.33337H5.78326V31.6667H34.1666V14.025H17.1333Z"
        fill="#C2E2FF"
      />
    </svg>
  );
});
